var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isPlatformBrowser } from '@angular/common';
import { OnInit, Testability, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, } from '@angular/router';
import { LinkTags } from '@freelancer/link-tags';
import { TimeUtils } from '@freelancer/time-utils';
import { Tracking } from '@freelancer/tracking';
import { filter } from 'rxjs/operators';
// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
// Application-wide code should be avoided as much as possible; does your code
// needs:
// - to be loaded on ALL logged-in pages?
// - AND to be loaded on ALL logged-out pages?
// - AND to be loaded on the Admin?
// - ...
// Probably not.
var AppComponent = /** @class */ (function () {
    function AppComponent(platformId, siteName, timeUtils, testability, activatedRoute, router, tracking, title, linksTags) {
        var _this = this;
        this.siteName = siteName;
        this.timeUtils = timeUtils;
        this.testability = testability;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.tracking = tracking;
        this.title = title;
        this.linksTags = linksTags;
        this.isBrowser = isPlatformBrowser(platformId);
        this.router.events.subscribe(function (event) {
            // track page views
            if (event instanceof NavigationEnd) {
                _this.tracking.trackPageView(getRecursiveRouteData(_this.activatedRoute.snapshot).is404);
            }
            // reset to default title on navigation.
            if (event instanceof NavigationStart) {
                _this.title.setTitle(_this.siteName);
            }
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.linksTags.setSiteWideLinks();
        // FIXME: detect Protractor env better
        if (this.isBrowser && window.location.host === 'localhost:5000') {
            this.router.events
                .pipe(filter(function (event) { return event instanceof NavigationEnd; }))
                .subscribe(function () {
                var pendingTasks;
                var timerDone = false;
                var isStable = false;
                var timeoutId = _this.timeUtils.setTimeout(function () {
                    console.warn('Pending tasks blocking zone stabilization:', pendingTasks);
                    timerDone = true;
                }, 5000);
                _this.testability.whenStable(function (e) {
                    console.log('zone stable');
                    isStable = true;
                    clearTimeout(timeoutId);
                }, 0, function (e) {
                    pendingTasks = e;
                    if (timerDone && !isStable) {
                        console.warn('Pending tasks blocking zone stabilization:', pendingTasks);
                    }
                });
            });
        }
    };
    return AppComponent;
}());
export { AppComponent };
/**
 * get config from nested child routes
 * TODO: we should enable paramsInheritanceStrategy instead
 */
export function getRecursiveRouteData(snapshot) {
    var data = snapshot.data;
    snapshot.children.forEach(function (child) {
        data = __assign({}, data, getRecursiveRouteData(child));
    });
    return data;
}
